import { Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { trainingModeStyles } from './training-mode-styles';

const TrainingModeWatermark: React.FC<TrainingModeWatermarkProps> = (
  props: TrainingModeWatermarkProps,
): JSX.Element => {
  const classes = trainingModeStyles();
  const { t } = useTranslation();

  return (
    <Typography
      className={`${classes.trainingWaterMark} ${props.supplementalStyles}`}
      data-testid={props.dataTestId}
    >
      {t('TrainingMode')}
    </Typography>
  );
};

export interface TrainingModeWatermarkProps {
  dataTestId?: string;
  supplementalStyles?: string;
}

export default TrainingModeWatermark;
